import { useAppPlatformContextOptions } from '../../../../contexts/app';
import { usePlanTypes } from '../../../app-init-data';
import { QuotePlanSchema } from '../server/map-quotes';

type PlanTypeSelectionProps = {
	allPlanQuotes: QuotePlanSchema[];
};

const usePlanTypeSelection = (props: PlanTypeSelectionProps) => {
	const { allPlanQuotes } = props;

	const { translate: t } = useAppPlatformContextOptions();
	const { planTypes: planCategories } = usePlanTypes();
	const allPlans = [
		{
			id: 0,
			name: `${t('quote-list:plans.all-plans')} (${allPlanQuotes?.length})`,
		},
	];

	const planTypes = allPlans.concat(
		planCategories?.map((plan) => {
			const count = allPlanQuotes?.filter((quote) => quote.planTypeIds.includes(plan.id)).length;

			return {
				id: plan.id,
				name: `${plan.name} (${count})`,
			};
		})
	);

	return {
		planTypes,
	};
};

export default usePlanTypeSelection;
